import apiProduct from '@/api/public/product';

const defaultState = () => ({
	productInternal: [],
	loadProductInternal: false,
	detailProductInternal: {},
	productInternalPagination: '',
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: ''
});

const state = defaultState();

const getters = {
};

const mutations = {
	setProductInternal(state, data) {
		state.productInternal = data.data
		state.productInternalPagination = data.pagination;
	},
	setloadProductInternal(state, data) {
		state.loadProductInternal = data
	},
	setDetailProductInternal(state, data) {
		state.detailProductInternal = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearProductInternal(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	async getProductInternal({ commit }, params) {
		commit('setloadProductInternal', true);
		return new Promise((resolve) => {
			apiProduct.getProductInternal(params).then(({ data: { data } }) => {
				commit('setProductInternal', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setProductInternal', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadProductInternal', false);
			});
		});
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};